const sliderData = [
  'https://patchwiki.biligame.com/images/blhx/0/0f/8wmjloeawizptm9gak75rewlamndw4e.png',
  'https://patchwiki.biligame.com/images/blhx/a/a6/e7ndi4sgk90jkw6heffgy5oi1j48ejo.png',
  'https://patchwiki.biligame.com/images/blhx/8/87/ai00y3dhf417yh7c4idqizn6vvmg6ms.png',
];

export default sliderData;
